import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { TransportCreationProfile, TransportCreationProfileNumberPlate } from "../../transport-creation-profiles.model";
import { ConfirmDialogComponent, ConfirmDialogData } from "@sdbn/tmc-legacy";


@Component({
  selector: "app-number-plate",
  templateUrl: "./select-number-plate-entry.html",
  styleUrls: ["./select-number-plate-entry.scss"],
})
export class SelectNumberPlateEntry implements OnInit, OnChanges {

  @Input() selectedProfile: TransportCreationProfile;

  @Output() deleteClicked = new EventEmitter<TransportCreationProfileNumberPlate>();

  @Output() changeActiveClicked = new EventEmitter<TransportCreationProfileNumberPlate>();

  @Output() addNewNumberPlateClicked = new EventEmitter<TransportCreationProfileNumberPlate>();

  numberPlates: TransportCreationProfileNumberPlate[];

  numberPlatesForm: FormGroup;

  newNumberPlate: string;

  ngOnChanges(changes: SimpleChanges) {
    this.numberPlates = changes.selectedProfile.currentValue.transportCreationProfileNumberPlates;
  }


  constructor(private dialog: MatDialog) {
    this.numberPlatesForm = new FormGroup({
      newNumberPlate: new FormControl("", [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.numberPlates = this.selectedProfile.transportCreationProfileNumberPlates;

    this.numberPlatesForm.valueChanges.subscribe(value => {
      this.newNumberPlate = value.newNumberPlate;
    }
    );
  }

  changeActive(numberPlate: TransportCreationProfileNumberPlate) {
    numberPlate.active = !numberPlate.active;
    this.changeActiveClicked.emit(numberPlate);

  }

  delete(
    numberPlate: TransportCreationProfileNumberPlate
  ) {
    const dialogData: ConfirmDialogData = {
      titleKey:
        "tmc-yard.ui.admin.transport-creation-profiles.number-plate.delete.confirm-dialog.title",
      messageKey:
        "tmc-yard.ui.admin.transport-creation-profiles.number-plate.delete.confirm-dialog.message",
      confirm: () => {
        const index = this.numberPlates.indexOf(numberPlate);
        this.numberPlates.splice(index, 1);
        this.deleteClicked.emit(numberPlate);
      },
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });
  }

  addNewNumberPlate() {
    const newTransportCreationNumberPlate = new TransportCreationProfileNumberPlate({
      active: true,
      numberPlate: this.newNumberPlate,
    });

    this.addNewNumberPlateClicked.emit(newTransportCreationNumberPlate);

    this.numberPlatesForm.reset();
  }

  addNewEnabled() {
    return this.numberPlatesForm.valid;
  }
}
